export enum Language {
    EN_US = 'EN-US',
    EN_CA = 'EN-CA',
    FR_CA = 'FR-CA',
}
